import React, { useEffect } from "react";
import {
  Paper,
  Box,
  Button,
  IconButton,
  InputBase,
  Pagination,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { AdminButton, TableMui } from "../../components/mui";
import { Link, useNavigate } from "react-router-dom";


const Products = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "RollingAdz: Jobs Requests" || "Default Title";
  }, []);

  const handleFieldButtonClick = () => {
    navigate("/admin/add-product");
  };
  const data = [
    {
      vehicle_type: "SUV",
      title: "Powerful SUV",
      product_description: "A powerful SUV for all your adventures",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Compact",
      title: "Economical Compact Car",
      product_description: "An economical and compact car for everyday use",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Sports Car",
      title: "High-Performance Sports Car",
      product_description: "Experience the thrill of speed with our sports car",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Truck",
      title: "Heavy-Duty Truck",
      product_description: "A heavy-duty truck for hauling and transporting",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Electric Car",
      title: "Environment-Friendly Electric Car",
      product_description: "Go green with our electric car",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Compact",
      title: "Economical Compact Car",
      product_description: "An economical and compact car for everyday use",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Sports Car",
      title: "High-Performance Sports Car",
      product_description: "Experience the thrill of speed with our sports car",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Truck",
      title: "Heavy-Duty Truck",
      product_description: "A heavy-duty truck for hauling and transporting",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      vehicle_type: "Truck",
      title: "Heavy-Duty Truck",
      product_description: "A heavy-duty truck for hauling and transporting",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    // ... Add more records ...
  ];
  

  return (
    <Box component={Paper} sx={{ marginBottom: "20px", padding: "20px" }}>
      <div className="container d-flex justify-content-between">
        <div
          className="d-flex justify-content-between align-items-center px-4 col-md-6"
          style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
        >
          <InputBase
            className=""
            sx={{
              ml: 1,
              flex: 1,
              px: 1,
            }}
            placeholder="Search..."
            type="search"
          />
          <Box
            sx={{
              width: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
            }}
          >
            <IconButton
              type="button"
              sx={{
                p: "5px",
                backgroundColor: "#3E4755",
                color: "white",
                "&:hover": {
                  backgroundColor: "#3E4755",
                  color: "white",
                },
              }}
              aria-label="search"
            >
              <Search style={{ fontSize: 25 }} />
            </IconButton>
          </Box>
        </div>
        <div>
          <AdminButton
            onClick={() => {
              navigate("/admin/add-product" , {state:"Add"});
            }}
            name="Add New"
          />
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <h1 style={{ color: "black" }}>Products</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            vehicle_type: (
              <>
               Product type <FilterAltOutlinedIcon />
              </>
            ),
            title: (
              <>
                Title <FilterAltOutlinedIcon />
              </>
            ),
            product_description: (
              <>
                Product Description <FilterAltOutlinedIcon />
              </>
            ),
            // view: "Button",
          }}
          td={data}
          customBtn={(row) => <CustomBtn row={row}  />}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
        
      </div>
    </Box>
  );
};
function CustomBtn({ row }) {
  console.log(row);
  const navigate = useNavigate();

  const blogDetail = (item) => {
    console.log(item.role, "nassjajhdajhdsa");
    if (item.role === "Installer") {
      navigate("/installeraccount");
    } else if (item.role === "Advertiser") {
      navigate("/advertiser-account");
    } else if (item.role === "Photographer") {
      navigate("/photograperaccount");
    } else if (item.role === "Vehicle Owner") {
      navigate("/vehicleowneraccount");
    } else if (item.role === "DesignerAccount") {
      navigate("/designeraccount");
    }
  };

  const handleDelete = async (id) => {
    const response = window.confirm(
      "Are you sure you want to delete this user?"
    );
    //  const response= await apiClient.delete(`blog/${id}/`)
    //  if(response.status!=204)
    //  return
    //  else{
    //   fetchData(Endpoint+offset)
    //    alert('deleted success fully')

    //  }
  };
 
  function edit() {
    navigate("/admin/add-product",{state:"Edit "})
  }

  return (
    <div className="d-flex gap-3 justify-content-center">
    <AdminButton  name="Edit"
     
    onClick={() =>edit()}
    />

<AdminButton
        className="btn btn-danger"
        style={{
          backgroundColor: "red",
          "&:hover": { backgroundColor: "#e32636" },
        }}
        onClick={() => handleDelete(row.id)}
        name="Delete"
      />

    
  </div>
  );
}

export default Products;
